import filter from "lodash/filter";
import { Icon } from "@iconify/react";
import { sentenceCase } from "change-case";
import { useState, useEffect, useContext } from "react";
import eyeIcon from "@iconify/icons-akar-icons/eye";
import bxsEdit from "@iconify/icons-bx/bxs-edit";

import { Link as RouterLink } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";

import {
  Card,
  Table,
  Stack,
  IconButton,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Switch,
  ToggleButtonGroup,
  ToggleButton,
  Button,
  useTheme,
  Box,
  TableFooter,
} from "@mui/material";
import { styled } from "@mui/material/styles";

import Page from "../components/Page";
import Label from "../components/Label";
import Scrollbar from "../components/Scrollbar";
import SearchNotFound from "../components/SearchNotFound";
import { TableTitle, TableHeader } from "../components/_dashboard/user";
import { useDispatch, useSelector } from "react-redux";

import { SearchContext } from "../Context/searchContext";
import { useTranslation } from "react-i18next";
import { db } from "../database/db";
import { doc, updateDoc, deleteDoc, getDoc } from "firebase/firestore";
import { getData } from "../database/db";
import { setUsers } from "../store";
import phone from "../assets/callPhone.png";
import apple from "../assets/apple.png";
import facebook from "../assets/facebook.png";
import gmail from "../assets/gmail.png";

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(
      array,
      (_user) => _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1
    );
  }
  return stabilizedThis.map((el) => el[0]);
}

export const getSignUpType = (objectEmail, objectPhone) => {
  if (!objectEmail) {
    return "Phone";
  } else if (objectEmail) {
    const afterAtTheRateReversed = objectEmail
      .split("@")[1]
      .split("")
      .reverse()
      .join("");
    const dotIndex = afterAtTheRateReversed.indexOf(".");
    const exceptFirstLetter = afterAtTheRateReversed
      .substring(dotIndex + 1)
      .split("")
      .reverse()
      .join("");
    const signUpType =
      exceptFirstLetter.charAt(0).toUpperCase() + exceptFirstLetter.slice(1);

    return signUpType;
  }
};

export const renderSignupIcon = (objectEmail, objectPhone, align) => {
  const signupType = getSignUpType(objectEmail, objectPhone);
  if (signupType === "Phone") {
    return (
      <div style={{ display: "flex", justifyContent: align }}>
        <img src={phone} width="20rem"></img>
      </div>
    );
  } else if (signupType === "Gmail") {
    return (
      <div style={{ display: "flex", justifyContent: align }}>
        <img src={gmail} width="25rem"></img>
      </div>
    );
  } else if (signupType === "Facebook") {
    return (
      <div style={{ display: "flex", justifyContent: align }}>
        <img src={facebook} width="30rem"></img>
      </div>
    );
  } else if (
    objectEmail.includes("appleid") ||
    objectEmail.includes("icloud")
  ) {
    return (
      <div style={{ display: "flex", justifyContent: align }}>
        <img src={apple} width="30rem"></img>
      </div>
    );
  } else {
    return <div style={{ display: "flex", justifyContent: align }}>-</div>;
  }
};

export default function UserList() {
  const [page, setPage] = useState(0);
  const dispatch = useDispatch();
  const [order, setOrder] = useState("asc");
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState("name");
  const [search, setSearch] = useContext(SearchContext);

  const [rowsPerPage, setRowsPerPage] = useState(10);
  const { t } = useTranslation();
  const [blocking, setBlocking] = useState("unblocked");

  const [blockingInfo, setblockingInfo] = useState([]);

  const TABLE_HEAD = [
    { id: "sno", label: "User #", alignRight: false },
    { id: "username", label: t("User_Name"), alignRight: false },
    { id: "email", label: t("Email_or_phone"), alignRight: false },
    { id: "signupprocess", label: t("Sign_Up_Process"), alignRight: false },
    // { id: "displayName", label: t("Name"), alignRight: false },
    // { id: "gender", label: t("Gender"), alignRight: false },
    { id: "urFansCounter", label: t("Followers"), alignRight: false },
    { id: "following", label: t("Following"), alignRight: false },
    { id: "stars", label: t("Fire Token"), alignRight: false },
    // { id: "brokerages", label: t("Allowed_Brokerages"), alignRight: false },
    // { id: "personalStatus", label: "Personal Status", alignRight: false },
    { id: "status", label: t("Status"), alignRight: false },
    { id: "action", label: t("Action"), alignRight: false },
    { id: "blocking", label: t("Blocking"), alignRight: false },
    { id: "delete", label: t("Delete"), alignRight: false },
  ];
  const userList = useSelector((state) => state.user.data);

  // handle blockingchange will alter the state variable containing all the information about blocking of each user
  // the moment it will alter the function will re render taking the values from the

  const handleChangeBlocking = async (user, shouldBlock) => {
    const docRef = doc(db, "users", user.id);
    // await updateDoc(docRef, {
    //   isBlocked: shouldBlock,
    // }).then(() => {
    //   console.log("Succesfully Blocked user");
    //   if (shouldBlock) {
    //     toast.error(`${user.displayName} has been blocked`, {
    //       position: "top-right",
    //     });
    //   } else {
    //     toast.success(`${user.displayName} has been Unblocked`, {
    //       position: "top-right",
    //     });
    //   }
    // });

    console.log(docRef);
    if (shouldBlock) {
      toast.error(`${user.name} has been blocked`, {
        position: "top-right",
      });
    } else {
      toast.success(`${user.name} has been Unblocked`, {
        position: "top-right",
      });
    }
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = userList.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleDeleteUser = async (id, email, password) => {
    await deleteDoc(doc(db, "User", id));
    const data = await getData("User");
    dispatch(setUsers(data));
  };

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - userList.length) : 0;

  const filteredUsers = applySortFilter(
    userList,
    getComparator(order, orderBy)
  );

  const isUserNotFound = filteredUsers.length === 0;

  const TableCellStyles = styled((props) => <TableCell {...props} />)(
    ({ theme }) => ({
      border: "1px solid #e3e6f0",
      fontSize: "12px",
    })
  );

  useEffect(() => {
  }, [search]);

  return (
    <Page title="User | User Details">
      <ToastContainer />
      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={3}
        >
          <Typography variant="h3" sx={{ color: "info.main" }}>
            {t("Users")}
          </Typography>
        </Stack>

        <Card sx={{ borderRadius: "5px" }}>
          <TableTitle title={t("List_of_Users")} />

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800, p: "10px" }}>
              <Table>
                <TableHeader
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={userList.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {filteredUsers
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)

                    .map((user, index) => {
                      const {
                        id,
                        name,
                        email,
                        phone,
                        bio,
                        allowedBrokerages,
                        purchaseToken,
                        isPaid,
                      } = user;

                      // const isBlocked= blockingInfo.filter((blk) => blk.id === id)

                      // console.log("isBlocked", isBlocked)
                      const isBlocked = false;
                      // const isItemSelected = selected.indexOf(name) !== -1;
                      // if (

                      // name.toLowerCase().indexOf(search.toLowerCase()) === -1

                      // ) {
                      // return null;
                      // } else {
                      return (
                        <TableRow
                          hover
                          key={id}
                          tabIndex={-1}
                          role="checkbox"
                          // selected={isItemSelected}
                          // aria-checked={isItemSelected}
                        >
                          <TableCellStyles align="left">
                            {index + 1}
                          </TableCellStyles>

                          <TableCellStyles align="left">
                            {/* {getLoginType(user)} */}
                            <RouterLink to="/viewuser" state={user} style={{ textDecoration: 'none', color: '#4e73df', fontWeight: 'bold' }}>
                              {name ? name : "-"}
                            </RouterLink>
                          </TableCellStyles>

                          <TableCellStyles>
                            {email && phone ? email : !email ? phone : email}
                          </TableCellStyles>

                          <TableCellStyles align="left">
                            {renderSignupIcon(email, phone, "center")}
                          </TableCellStyles>

                          {/* <TableCellStyles align="left">
                              {name?name:"N/A"}
                            </TableCellStyles> */}

                          <TableCellStyles align="left">
                            {Math.trunc(Math.random() * 100)}
                          </TableCellStyles>
                          <TableCellStyles align="left">
                            {Math.trunc(Math.random() * 100)}
                          </TableCellStyles>
                          <TableCellStyles align="left">
                            {Math.trunc(Math.random() * 100)}
                          </TableCellStyles>

                          {/* <TableCellStyles align="left">
                                {!allowedBrokerages? 0 : allowedBrokerages}
                            </TableCellStyles> */}

                          <TableCellStyles align="left">
                            "Status"
                          </TableCellStyles>

                          <TableCellStyles align="left">
                            <IconButton
                              component={RouterLink}
                              to="/viewuser"
                              state={user}
                              aria-label="view"
                              size="small"
                              sx={{ color: "info.main" }}
                            >
                              <Icon icon={eyeIcon} />
                            </IconButton>
                          </TableCellStyles>

                          <TableCellStyles align="center">
                            <div style={{ display: "flex" }}>
                              <Button
                                onClick={() => handleChangeBlocking(user, true)}
                                disabled={isBlocked ? true : false}
                              >
                                Block
                              </Button>
                              <Button
                                onClick={() =>
                                  handleChangeBlocking(user, false)
                                }
                                disabled={!isBlocked ? true : false}
                              >
                                UnBlock
                              </Button>
                            </div>

                            <Label
                              variant="ghost"
                              color={isBlocked ? "error" : "success"}
                            >
                              {isBlocked ? "Blocked" : "Not Blocked"}
                            </Label>
                          </TableCellStyles>

                          <TableCellStyles align="center">
                            <IconButton
                              onClick={() => handleDeleteUser(id, email)}
                            >
                              <Icon icon="ic:round-delete" />
                            </IconButton>
                          </TableCellStyles>
                        </TableRow>
                      );
                      // }
                    })}

                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCellStyles colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>

                <TableFooter>
                  <TableRow>
                    <TablePagination
                      rowsPerPageOptions={[
                        5,
                        10,
                        25,
                        { label: "All", value: -1 },
                      ]}
                      colSpan={4}
                      count={filteredUsers.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      SelectProps={{
                        inputProps: {
                          "aria-label": "rows per page",
                        },
                        native: true,
                      }}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                      ActionsComponent={TablePaginationActions}
                    />
                  </TableRow>
                </TableFooter>

                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCellStyles
                        align="center"
                        colSpan={6}
                        sx={{ py: 3 }}
                      >
                        <SearchNotFound />
                      </TableCellStyles>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>
        </Card>
      </Container>
    </Page>
  );
}

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}
